<template>
  <component :is="type + 'Add'" v-if="type" ref="addTechnicalModal" />
</template>
<script>
import PowerAdd from './power/Add'
import GasAdd from './gas/Add'
import WaterAdd from './water/Add'
import HeatAdd from './heat/Add'

export default {
  components: {
    PowerAdd,
    GasAdd,
    WaterAdd,
    HeatAdd,
  },
  data() {
    return {
      loading: false,
      type: null,
      edit: false,
      id: null,
    }
  },
  methods: {
    saveTechnical(e) {
      e.preventDefault()
      this.$refs.addTechnicalModal.$validator.validateAll().then(() => {
        if (
          !this.$refs.addTechnicalModal.errors.any() &&
          !this.$refs.addTechnicalModal.loading
        ) {
          if (this.edit) {
            this.$api
              .post(
                'energetics/edit_technical',
                this.$refs.addTechnicalModal.form,
              )
              .then((res) => {
                this.$swal({
                  type: 'success',
                  position: 'top',
                  showCloseButton: true,
                  text: res.data.message,
                  timer: 5000,
                })
                this.$root.$emit('modal-hide', 'add-technical')
                this.$root.$emit('reloadEnergeticTechnicalData')
              })
              .catch(() => {
                this.$swal({
                  type: 'error',
                  position: 'top',
                  showCloseButton: true,
                  text: 'Vyskytla sa chyba pri aktualizovaní hodnôt',
                  timer: 5000,
                })
              })
          } else {
            this.$api
              .post(
                'energetics/add_technical',
                this.$refs.addTechnicalModal.form,
              )
              .then((res) => {
                this.$swal({
                  type: 'success',
                  position: 'top',
                  showCloseButton: true,
                  text: res.data.message,
                  timer: 5000,
                })
                this.$root.$emit('reloadEnergeticTechnicalData')
                this.$root.$emit('modal-hide', 'add-technical')
              })
              .catch(() => {
                this.$swal({
                  type: 'error',
                  position: 'top',
                  showCloseButton: true,
                  text: 'Vyskytla sa chyba pri pridávaní hodnôt',
                  timer: 5000,
                })
              })
          }
        } else {
          this.$swal({
            type: 'warning',
            position: 'top',
            showCloseButton: true,
            text: 'Formulár nieje správne vyplnený',
            timer: 5000,
          })
        }
      })
    },
  },
}
</script>
